//按钮的
import './fastclick.js'
import './option.js'
import './load.js'


// WEBPACK FOOTER //
// ./src/pages/webgl/src/index.js